import {Component, OnInit} from '@angular/core';
import {AdminService} from '../../../../services/admin.service';
import {PrefixService} from '../../../../services/frefix.service';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import {AddStepUserService} from './add-step-user.service';

@Component({
  selector: 'app-add-user-steps',
  templateUrl: './add-user-steps.component.html',
  styleUrls: ['./add-user-steps.component.css']
})
export class AddUserStepsComponent implements OnInit {
  selectedUser;
  lastAddedUser: any;
  successInfo = false;
  errorInfo = false;
  allUsers: any[] = [];           // List of users;
  addedUsers: any[] = [];

  constructor(private prefixService: PrefixService,
              private adminService: AdminService,
              public stepsControllerService: StepsControllerService,
              private addStepUserService: AddStepUserService) {
  }

  ngOnInit() {
    this.successInfo = false;
    this.errorInfo = false;
    this.adminService.getUsersOusideStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          const usersUnsorted = response.body;
          this.allUsers = usersUnsorted.sort((a, b) => a['firstName'] > b['firstName'] ? 1 : a['firstName'] === b['firstName'] ? 0 : -1);

          // Add "Null User"
          // TODO сделать нормально;
          this.allUsers.reverse();
          this.allUsers.push(null);
          this.allUsers.reverse();

          this.selectedUser = this.allUsers[0];
        }
      },
      () => {
        this.successInfo = false;
        this.errorInfo = true;
      }
    );
  }

  selectUser(user) {
    this.successInfo = false;
    this.errorInfo = false;
    this.selectedUser = user;
  }

  addUserToStandard() {
    if (this.selectedUser) {
      this.adminService.addUserToStandard(this.stepsControllerService.getCurrentStandard().id, this.selectedUser.id).subscribe(
        (response: any) => {
          this.successInfo = true;
          this.errorInfo = false;
          this.addedUsers.push(this.selectedUser);
          this.lastAddedUser = this.selectedUser;

          const uindex = this.allUsers.indexOf(this.selectedUser);
          this.allUsers.splice(uindex, 1);
          this.selectedUser = this.allUsers[0];

          if (this.stepsControllerService.activeStep === 5) {
            this.stepsControllerService.stepSixDisabled = true;
          }

        },
        () => {
          this.successInfo = false;
          this.errorInfo = true;
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/add-user-steps/add-user-steps.component.ts